import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    margin: "0 auto"
  },
  rootPopover: {
    position: "fixed"
  },
  rootPopoverBack: {
    width: "100%"
  },
  conditionsBookButton: {
    display: "flex",
    justifyContent: "left",
    cursor: "pointer",
    maxWidth: "100%",
    textTransform: "capitalize",
    fontSize: 18,
    [theme.breakpoints.down("xs")]: {
      padding: 0
    }
  },
  selectedBookName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "inherit",
    display: "flex",
    alignItems: "center"
  },
  selectedBookNameIcon: {
    marginLeft: 5,
    transition: "all .2s",
    verticalAlign: "middle"
  },
  selectedBookNameIconIsOpen: {
    transform: "rotate(180deg)"
  },
  dialogRoot: {},
  dialogContainer: {},
  backArrowIcon: {
    fontSize: 30,
    marginRight: 8,
    "&:hover": {
      cursor: "pointer"
    }
  },
  dialogTitleHeader: {
    padding: "18px 20px 14px",
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    display: "flex",
    alignItems: "center",
    minHeight: 60,
    maxHeight: 60,
    [theme.breakpoints.down("md")]: {
      padding: "18px 20px 16px"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "10px"
    }
  },
  dialogMainTitle: {
    fontSize: 20,
    lineHeight: 1
  },
  titleSmall: {
    fontSize: 16,
    marginBottom: "8px"
  },
  dialogSubtitle: {
    fontSize: 12
  },
  closeButton: {
    position: "absolute",
    right: 0,
    top: -2,
    color: theme.palette.text.primary
  },
  closeButtonHide: {
    display: "none"
  },
  closeButtonIcon: {
    fontSize: 28
  },
  dialogContent: {
    padding: 0
  },
  dialogList: {},
  listItem: {
    padding: "6px 20px 6px 24px",
    borderBottom: "1px solid #ececec",
    minHeight: 60,
    [theme.breakpoints.down("xs")]: {
      padding: "6px 10px",
      minHeight: 50
    }
  },
  currentDateRange: {
    fontSize: 12,
    color: "#909090"
  },
  listItemSelected: {
    backgroundColor: "#ececec"
  },
  listItemSmall: {},
  listItemIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 14,
    border: "1px solid #000000",
    width: 31,
    height: 18,
    minWidth: "unset",
    marginRight: 14,
    [theme.breakpoints.down("xs")]: {
      marginRight: 10
    }
  },
  listItemIconActive: {
    backgroundColor: theme.palette.secondary.main
  },
  checkIcon: {
    width: 25,
    height: 12,
    border: "1px solid #000000",
    borderRadius: 7,
    color: "white"
  },
  checkIconActive: {
    backgroundColor: "#103827"
  },
  listItemText: {
    "& .MuiTypography-body1": {
      fontSize: 18,
      lineHeight: 1.3
    },
    [theme.breakpoints.down("xs")]: {
      "& .MuiTypography-body1": {
        fontSize: 16
      }
    }
  },
  listItemTextContent: {
    display: "flex",
    flexDirection: "column"
  },
  filterDateRange: {
    fontSize: 14,
    color: "#9a9a9a"
  },
  listItemTextActive: {
    "& .MuiTypography-body1": {
      color: theme.palette.secondary.dark
    }
  },
  selectedItemIcon: {
    fontSize: 30
  },
  closable: {
    justifyContent: "space-between"
  },
  facilityCode: {
    border: "1px solid grey",
    padding: "0 6px",
    marginRight: 8,
    borderRadius: 3
  },
  selectedFilterOptionContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    lineHeight: 1
  },
  selectedFilterOption: {},
  selectedFilterDate: {
    fontSize: 12,
    color: "#585858"
  },
  arrowBackIconHidden: {
    display: "none"
  }
}));
